import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CourseMaterialTypeForm from '../../../components/forms/CourseMaterialTypeForm';
import { useCourseMaterialTypeApi } from '../../../hooks/useCourseMaterialTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CourseMaterialTypeDTO } from '../../../services/apiClient';

const CourseMaterialTypeCreate: React.FC = () => {
  const { create, isLoading } = useCourseMaterialTypeApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Course Material Types', href: '/admin/coursematerialtypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CourseMaterialTypeDTO) => {
    try {
      await create(data);
      navigate('/admin/coursematerialtypes');
    } catch (error) {
      console.error('Error creating CourseMaterialType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/coursematerialtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.CourseMaterialType.Edit'
    >
        <CourseMaterialTypeForm
          initialValues={{} as CourseMaterialTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/coursematerialtypes')}
        />
    </AdminLayout>
  );
};

export default CourseMaterialTypeCreate;